import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadCarrierFieldsValidationFailed, loadCarrierFieldsValidationSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* loadCarrierFieldsValidation(action) {
  try {
    const {
      id,
      data,
    } = action.payload;
    const url = `${BACKEND_URL}/registries/carriers/${id}/fields-validation`;
    const dataResponse = yield makeRequest(url, data, action, 'POST', true);
    if (dataResponse.status === OK) {
      const data = yield dataResponse.json();
      yield put(loadCarrierFieldsValidationSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadCarrierFieldsValidationFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(loadCarrierFieldsValidationFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
